import React from 'react';
import styled from 'styled-components';
import { M } from '@dashboard-experience/mastodon';
import { ResidentialAddress } from 'types/report';

const FieldLabel = styled.span`
  margin-bottom: 0.5rem;
  display: block;
`;

const FirstGridCol = styled(M.GridCol)`
  padding-left: 0;
`;

interface ResidentialAddressesProps {
  addresses: ResidentialAddress[];
  lookbackYears?: string | number | null;
}

const ResidentialAddresses: React.FC<ResidentialAddressesProps> = ({
  addresses,
  lookbackYears,
}) => {
  const getAddressTitle = (address: ResidentialAddress, index: number) => {
    if (address.isCurrent) {
      return `Address ${index + 1} (Current)`;
    }
    return `Address ${index + 1}`;
  };

  const getLookbackTitle = () => {
    if (!lookbackYears) {
      return 'Residential addresses';
    }

    const numericValue = Number(lookbackYears);
    if (!isNaN(numericValue)) {
      return `Residential addresses for the last ${lookbackYears} years`;
    }

    return 'Residential addresses';
  };

  return (
    <div className='mt-3'>
      <div className='md-flex mb-3'>
        <div>
          <div className='mb-3 font-weight-bold'>{getLookbackTitle()}</div>
        </div>

        <div>
          {addresses.map((address, index) => {
            const isLast = index === addresses.length - 1;

            return (
              <React.Fragment
                key={`${address.fromDate}-${address.fullAddress}`}
              >
                <div className='mb-3'>{getAddressTitle(address, index)}</div>

                <M.Grid>
                  <M.GridRow className={isLast ? 'mb-0' : 'mb-md-4'}>
                    <FirstGridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>From</FieldLabel>
                      {address.fromDate}
                    </FirstGridCol>
                    <M.GridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>To</FieldLabel>
                      {address.toDate || '-'}
                    </M.GridCol>
                    <M.GridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>
                        Address
                      </FieldLabel>
                      {address.fullAddress?.trim() || 'No fixed address'}
                    </M.GridCol>
                  </M.GridRow>
                </M.Grid>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ResidentialAddresses;
